import React from 'react'

export default function Haboutus() {
  return (
    <div id="about" class="relative bg-white overflow-hidden mt-16">
    <div class="max-w-7xl mx-auto">
        <div class="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32">
            <svg class="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2"
                fill="currentColor" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
                <polygon points="50,0 100,0 50,100 0,100"></polygon>
            </svg>

            <div class="pt-1"></div>

            <main class=" mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 lg:mt-20 lg:px-8 ">
                <div class="sm:text-center lg:text-left">
                    <h2 class=" text-2xl tracking-tight font-extrabold text-gray-900 sm:text-3xl md:text-4xl">
                        About Us
                    </h2>
                    <h1 className='my-1 text-2xl tracking-tight font-extrabold text-green-600 sm:text-3xl md:text-4xl'>Large Enough to Handle… Small Enough to Care</h1>

                    <p className='mt-10 text-lg'>
                    Synonymous with facilitating hassle-free and personalized flow of goods between the point of origin and the point of destination, Jay Malhar Mauli Roadways offers end-to-end logistic solutions for individuals and corporate alike. Ever since its inception during the year 1988, Jay Malhar Mauli Roadways has applied analytics to logistics services, thus redefining each phase in the logistic process, from transportation to handling, procurement and distribution through 20 Feet & 40 Feet Container / Trailer. Since inception of our company, we have provided best-in-the-industry services keeping in mind the flexibility, timely delivery & responsive attributes for all our valued customers – both in the areas of Import as well as Export.
                    </p>
                </div>
            </main>
        </div>
    </div>
    <div class="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
        <img class=" bg2 " src="/images/Truck3.png" alt=""/>
    </div>
</div>
  )
}
